import React from 'react';
import KnowledgeLibraryOntologyFilter from './KnowledgeLibraryOntologyFilter';
import KnowledgeLibraryClassificationFilter, { ClassificationFilterSortDirection, KnowledgeLibraryClassificationFilterValue } from './KnowledgeLibraryClassificationFilter';

interface KnowledgeLibraryFilterBarProps {
    facilityHierarchy: IFacilityHierarchyPart | null;
    selectedOntologyId?: string;
    onOntologyChange: (ontologyId?: string) => void;
    showFavoritesOnly: boolean;
    onFavoritesToggle: () => void;
    searchText: string;
    onSearchTextChange: (value: string) => void;
    showClassificationFilter?: boolean;
    classificationFilterValues?: KnowledgeLibraryClassificationFilterValue[];
    selectedClassificationFilterIds?: Set<string> | null;
    onClassificationFilterChange?: (selectedIds: Set<string> | null) => void;
    classificationFilterSortDirection: ClassificationFilterSortDirection;
    onClassificationFilterSortDirectionChange: (sortDirection: ClassificationFilterSortDirection) => void;
}

const KnowledgeLibraryFilterBar: React.FC<KnowledgeLibraryFilterBarProps> = ({
    facilityHierarchy,
    selectedOntologyId,
    onOntologyChange,
    showFavoritesOnly,
    onFavoritesToggle,
    searchText,
    onSearchTextChange,
    showClassificationFilter = false,
    classificationFilterValues,
    selectedClassificationFilterIds = null,
    onClassificationFilterChange,
    classificationFilterSortDirection,
    onClassificationFilterSortDirectionChange
}) => {
    return (
        <div className="knowledge-library-toolbar e-grid">
            <div className="knowledge-library-toolbar-section knowledge-library-toolbar-section-left">
                <button
                    type="button"
                    className={showFavoritesOnly ? 'e-btn e-flat knowledge-library-filter-toggle active' : 'e-btn e-flat knowledge-library-filter-toggle'}
                    title={showFavoritesOnly ? InovxLoader.t('facility:knowledgeBook.showAllKnowledgeBooks') : InovxLoader.t('facility:knowledgeBook.showFavoriteKnowledgeBooksOnly')}
                    onClick={onFavoritesToggle}
                >
                    <span className={`fa ${showFavoritesOnly ? 'fa-star' : 'fa-star-o'}`} aria-hidden="true"></span>
                    <span className="kb-filter-toggle-label">{InovxLoader.t('facility:knowledgeBook.favorites')}</span>
                </button>
            </div>
            <div className="knowledge-library-toolbar-section knowledge-library-toolbar-section-right">
                {showClassificationFilter && classificationFilterValues && onClassificationFilterChange && (
                    <div className="kb-classification-filter knowledge-library-classification-filter">
                        <KnowledgeLibraryClassificationFilter
                            values={classificationFilterValues}
                            selectedIds={selectedClassificationFilterIds}
                            onChange={onClassificationFilterChange}
                            sortDirection={classificationFilterSortDirection}
                            onSortDirectionChange={onClassificationFilterSortDirectionChange}
                        />
                    </div>
                )}
                {facilityHierarchy && (
                    <div className="kb-ontology-filter knowledge-library-ontology-filter">
                        <KnowledgeLibraryOntologyFilter
                            facilityHierarchy={facilityHierarchy}
                            selectedOntologyId={selectedOntologyId}
                            onChange={onOntologyChange}
                        />
                    </div>
                )}
                <div className="knowledge-library-search-group e-input-group e-control-wrapper">
                    <input
                        type="text"
                        className="e-input"
                        placeholder={InovxLoader.t('facility:menu.search')}
                        value={searchText}
                        onChange={(event) => onSearchTextChange(event.target.value)}
                    />
                    {searchText && (
                        <button
                            type="button"
                            className="knowledge-library-search-clear"
                            title={InovxLoader.t('common:clear')}
                            aria-label={InovxLoader.t('common:clear')}
                            onClick={() => onSearchTextChange('')}
                        >
                            <span className="e-icons e-close" aria-hidden="true"></span>
                        </button>
                    )}
                    <span className="e-input-group-icon e-search-icon e-icons" aria-hidden="true"></span>
                </div>
            </div>
        </div>
    );
};

export default KnowledgeLibraryFilterBar;
